import { render } from "./PersonnelList.vue?vue&type=template&id=69a328ec"
import script from "./PersonnelList.vue?vue&type=script&lang=js"
export * from "./PersonnelList.vue?vue&type=script&lang=js"
script.render = render

export default script